export const FETCH_END = "setArticles";
export const FETCH_START = "setLoading";
export const PURGE_AUTH = "logOut";
export const SET_ARTICLE = "setArticle";
export const SET_AUTH = "setUser";
export const SET_AUTH_UNAVAILABLE = "setAuthUnavailable";
export const SET_COMMENTS = "setComments";
export const ADD_COMMENT = "addComment";
export const REMOVE_COMMENT = "removeComment";
export const SET_ERROR = "setError";
export const SET_PROFILE = "setProfile";
export const SET_PROFILE_ERROR = "setProfileError";
export const SET_TAGS = "setTags";
export const TAG_ADD = "addTag";
export const TAG_REMOVE = "removeTag";
export const UPDATE_ARTICLE_IN_LIST = "updateArticleInList";
export const RESET_STATE = "resetModuleState";
